goog.require('el8.app.settings.reactTab');
goog.provide('el8.app.settings.insurance');

el8.app.settings.insurance = el8.app.settings.reactTab({
    containerId: 'settings-insurance',
    renderFnName: 'renderInsuranceSettings',
    props: {
      // TODO replace using EL8GLOBALS in settings/insurance components with just practiceId
      practiceId: el8Globals.PRACTICE_ID
    }
});
